(function () {
  function resyncCarousel(section) {
    document.dispatchEvent(new CustomEvent('product-card-carousel:resync', { detail: { section: section } }));
  }

  function initSection(section) {
    if (section.dataset.hotDealsInit === 'true') return;
    var slider = section.querySelector('slider-component');
    if (!slider || typeof slider.init !== 'function') return;

    var instance = slider.init();
    section.dataset.hotDealsInit = 'true';

    resyncCarousel(section);

    if (instance && instance.events && typeof instance.events.on === 'function') {
      instance.events.on('transitionEnd', function () {
        resyncCarousel(section);
      });
      instance.events.on('indexChanged', function () {
        resyncCarousel(section);
      });
    }
  }

  function run() {
    if (!window.customElements || !customElements.get('slider-component')) return;
    if (document.readyState === 'loading') return;
    document.querySelectorAll('.section-featured-collection-v3--hot-deals-card').forEach(initSection);
  }

  document.addEventListener('global.js loaded', run);
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll('.section-featured-collection-v3--hot-deals-card').forEach(initSection);
  });
  run();
})();
